module.exports = __webpack_public_path__ + "media/fresh/social-security-d521a57c.svg";